import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';
import { Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-open-dispatches',
    templateUrl: './open-dispatches.component.html',
    styleUrls: ['./open-dispatches.component.scss'],
    standalone: false
})
export class OpenDispatchesComponent implements OnInit, OnDestroy {

    constructor(private featureFlagService: FeatureFlagService) {
    }
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    ngOnInit(): void {
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.setWidgetFilters();
        });
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
    }

    @Input() chartType: string;
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.openDispatches;
    chartSearchFilters: widgetFilters[];

    private setWidgetFilters() {
        this.chartSearchFilters = this.featureFlagSet["days-aged-widget-filter"] ?
            [
                widgetFilters.customer,
                widgetFilters.customerInclusivity,
                widgetFilters.class,
                widgetFilters.svcConst,
                widgetFilters.state,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.acctMgr,
                widgetFilters.contAdmin,
                widgetFilters.svcMgr,
                widgetFilters.priority,
                widgetFilters.biller,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter,
                widgetFilters.status,
                widgetFilters.onCallRegion,
                widgetFilters.daysAged,
                widgetFilters.purchaser,
                widgetFilters.rank
            ]
            :
            [
                widgetFilters.customer,
                widgetFilters.customerInclusivity,
                widgetFilters.class,
                widgetFilters.svcConst,
                widgetFilters.state,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.acctMgr,
                widgetFilters.contAdmin,
                widgetFilters.svcMgr,
                widgetFilters.priority,
                widgetFilters.biller,
                widgetFilters.discreetBiller,
                widgetFilters.defaultSubmitter,
                widgetFilters.status,
                widgetFilters.onCallRegion,
                widgetFilters.purchaser,
                widgetFilters.rank
            ];
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
